import { useEffect, useRef } from 'react';

export function useAbort(): React.MutableRefObject<AbortController> {
  const abortRef = useRef<null | AbortController>(null);

  useEffect(() => {
    abortRef.current = new AbortController();

    return () => {
      abortRef.current?.abort('Component Unmounted');
    };
  }, []);

  return abortRef as React.MutableRefObject<AbortController>;
}
